/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {ContactDTO} from '../model/contactDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorContactService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer un nouveau contact
     * Cette requête permet de créer un nouveau contact associé à un affilié d&#39;un tenant à partir d&#39;un contactDTO.Le tenant est défini dans le paramètre de la requête X-Datastore-Id.&lt;br&gt;L&#39;affilié est défini dans le paramètre de la requête X-Partner-Id.&lt;br&gt;X-Datastore-Id est le &lt;b&gt;code du datastore&lt;/b&gt;.&lt;br&gt;X-Partner-Id est le &lt;b&gt;code de l&#39;affilié&lt;/b&gt;.&lt;br&gt;Si le contact est bien crée, la requête renvoie un code 201 (Created).&lt;br&gt;Si le contact n&#39;est pas crée, la requête renvoie un code 400 (Bad Request). Cela est dû à un problème de validation : &lt;br&gt;Le contact a déjà un ID.
     * @param xDataStoreID X-DataStoreID
     * @param contactDTO contactDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createContactUsingPOST(xDataStoreID: string, contactDTO: ContactDTO, observe?: 'body', reportProgress?: boolean): Observable<ContactDTO>;
    public createContactUsingPOST(xDataStoreID: string, contactDTO: ContactDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDTO>>;
    public createContactUsingPOST(xDataStoreID: string, contactDTO: ContactDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDTO>>;
    public createContactUsingPOST(xDataStoreID: string, contactDTO: ContactDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createContactUsingPOST.');
        }

        if (contactDTO === null || contactDTO === undefined) {
            throw new Error('Required parameter contactDTO was null or undefined when calling createContactUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ContactDTO>(`${this.basePath}/api/contacts`,
            contactDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer un contact d&#39;un affilié d&#39;un tenant par son email
     * Cette requête nous permet de supprimer un contact d&#39;un affilié d&#39;un tenant par son email.&lt;br&gt;Le tenant est défini dans le paramètre de la requête X-Datastore-Id.&lt;br&gt;X-Datastore-Id est le &lt;b&gt;code du datastore&lt;/b&gt;.&lt;br&gt;Si la requête est effectuée avec succès, la requête renvoie un code 204 (No Content).
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteContactUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteContactUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteContactUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteContactUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteContactUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteContactUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/contacts/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister tout les contacts d&#39;un affilié d&#39;un tenant
     * Cette requête nous permet de lister tout les contacts d&#39;un affilié d&#39;un tenant&lt;br&gt;Le tenant est défini dans le paramètre de la requête X-Datastore-Id.&lt;br&gt;L&#39;affilié est défini dans le paramètre de la requête X-Partner-Id.&lt;br&gt;X-Datastore-Id est le &lt;b&gt;code du datastore&lt;/b&gt;.&lt;br&gt;X-Partner-Id est le &lt;b&gt;code de l&#39;affilié&lt;/b&gt;.
     * @param xDataStoreID X-DataStoreID
     * @param X_PARTNER_ID X-PARTNER-ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllContactsUsingGET(xDataStoreID: string, X_PARTNER_ID: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ContactDTO>>;
    public getAllContactsUsingGET(xDataStoreID: string, X_PARTNER_ID: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContactDTO>>>;
    public getAllContactsUsingGET(xDataStoreID: string, X_PARTNER_ID: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContactDTO>>>;
    public getAllContactsUsingGET(xDataStoreID: string, X_PARTNER_ID: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getAllContactsUsingGET.');
        }

        if (X_PARTNER_ID === null || X_PARTNER_ID === undefined) {
            throw new Error('Required parameter X_PARTNER_ID was null or undefined when calling getAllContactsUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            queryParameters = queryParameters.set('X-PARTNER-ID', <any> X_PARTNER_ID);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ContactDTO>>(`${this.basePath}/api/contacts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir un contact d&#39;un tenant
     * Cette requête nous permet d&#39;obtenir un contact.&lt;br&gt;X-Datastore-Id est le &lt;b&gt;code du datastore&lt;/b&gt;.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContactUsingGET(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<ContactDTO>;
    public getContactUsingGET(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDTO>>;
    public getContactUsingGET(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDTO>>;
    public getContactUsingGET(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getContactUsingGET.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getContactUsingGET.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ContactDTO>(`${this.basePath}/api/contacts/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Modifier un contact
     * Cette requête permet de modifier un contact associé à un affilié d&#39;un tenant à partir d&#39;un contactDTO.Le tenant est défini dans le paramètre de la requête X-Datastore-Id.&lt;br&gt;L&#39;affilié est défini dans le paramètre de la requête X-Partner-Id.&lt;br&gt;X-Datastore-Id est le &lt;b&gt;code du datastore&lt;/b&gt;.&lt;br&gt;X-Partner-Id est le &lt;b&gt;code de l&#39;affilié&lt;/b&gt;.&lt;br&gt;Si le contact est bien modifié, la requête renvoie un code 200 (OK).&lt;br&gt;Si le contact n&#39;est pas modifié, la requête renvoie un code 400 (Bad Request).&lt;br&gt;Dans ce cas le DTO est invalide.&lt;br&gt;Si le contact n&#39;a pas pu être modifié, la requête renvoie un code 500 (Internal Server Error).
     * @param xDataStoreID X-DataStoreID
     * @param contactDTO contactDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateContactUsingPUT(xDataStoreID: string, contactDTO: ContactDTO, observe?: 'body', reportProgress?: boolean): Observable<ContactDTO>;
    public updateContactUsingPUT(xDataStoreID: string, contactDTO: ContactDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContactDTO>>;
    public updateContactUsingPUT(xDataStoreID: string, contactDTO: ContactDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContactDTO>>;
    public updateContactUsingPUT(xDataStoreID: string, contactDTO: ContactDTO, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateContactUsingPUT.');
        }

        if (contactDTO === null || contactDTO === undefined) {
            throw new Error('Required parameter contactDTO was null or undefined when calling updateContactUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<ContactDTO>(`${this.basePath}/api/contacts`,
            contactDTO,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
